export const AUTHENTICATION_TYPE_TEXTS: Record<string, string> = {
    Anonymous: stringResources.Anonymous_DisplayText,
    SAS: stringResources.AuthenticationType_SAS,
    Key: stringResources.AuthenticationType_AccountKey,
    OAuth2: stringResources.AuthenticationType_OAuth2,
    Basic: stringResources.Basic_DisplayText,
    Windows: stringResources.Windows_DisplayText,
    ServicePrincipal: stringResources.AuthenticationType_ServicePrincipal,
    UserAuth: stringResources.ModelName_UserAuthentication_NoPreview,
    AccountKeyAuthentication: stringResources.AuthenticationType_AccountKey,
    ServicePrincipalAuthentication: stringResources.AuthenticationType_ServicePrincipal,
    MSIAuthentication: stringResources.AuthenticationType_ManagedServiceIdentity,
    SasUriAuthentication: __IS_FABRIC_DPE__
        ? stringResources.AuthenticationType_SAS
        : stringResources.SasUri,
    Credential: stringResources.ModelName_Credential,
    UserAssignedManagedIdentity: stringResources.AuthenticationType_UserAssignedManagedIdentity,
    WorkspaceIdentity: stringResources.AuthenticationType_WorkspaceIdentity,
};
